import { render, staticRenderFns } from "./workspace_state_indicator.vue.js?vue&type=template&id=36aeb82e&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./workspace_state_indicator.vue?vue&type=template&id=36aeb82e&vue3"
import script from "./workspace_state_indicator.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./workspace_state_indicator.vue?vue&type=script&lang=js&vue3"
export * from "./workspace_state_indicator.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./workspace_state_indicator.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports